var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67444 10.5556C4.85141 9.82185 3.94356 9.06324 3.94356 7.8818C3.94356 6.52625 5.19962 5.58109 7.30135 5.58109C9.515 5.58109 10.3358 6.63817 10.4104 8.1927H13.1588C13.0718 6.05367 11.766 4.08874 9.16679 3.45449V0.730957H5.43591V3.41719C3.02328 3.93951 1.08323 5.50647 1.08323 7.90667C1.08323 10.7794 3.45855 12.2096 6.92826 13.0428C10.0373 13.789 10.6591 14.8834 10.6591 16.04C10.6591 16.8981 10.0498 18.2661 7.30135 18.2661C4.73948 18.2661 3.73215 17.1219 3.59535 15.6544H0.859375C1.00861 18.378 3.04815 19.9076 5.43591 20.4175V23.1162H9.16679V20.4424C11.5919 19.9823 13.5195 18.577 13.5195 16.0275C13.5195 12.4956 10.4975 11.2893 7.67444 10.5556Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.3754b8c52a5fb940e2c5e72ae2c2522e.svg";
export { ForwardRef as ReactComponent };